
import { Route } from '@/app/router'

const Plans = () => import('./index.vue')

const PlansProps = ['page', 'perPage']

export default [
	new Route('/plans', Plans)
		.as('Dashboard:Plans')
		.permissions(['ACTIVATE_PLAN'])
		.props(PlansProps)
]
